import { onMounted, ref } from '@vue/composition-api';
import { getMyCouponCount, getMyWePointsCount } from './api';
import { CustomException } from '@tencent/ppd-base-libs';

/**
 * 用户资产(优惠券、积分)模块
 */
export function useUserAssetsCount() {
  const isReady = ref(false);
  const assetsCountData = ref({
    /** 自动扣减券数量（展示时与手动启用券相加，也用于点击入口预判默认 Tab） */
    autoCouponCount: 0,
    /** 手动启用券数量（展示时与自动扣减券相加，也用于点击入口预判默认 Tab） */
    manualCouponCount: 0,
    wepointsCount: 0,
  });
  const initCouponCount = async () => {
    const { autoCount, manualCount } = await getMyCouponCount();
    assetsCountData.value.autoCouponCount = autoCount;
    assetsCountData.value.manualCouponCount = manualCount;
  };
  const initWePointsCount = async () => {
    assetsCountData.value.wepointsCount = await getMyWePointsCount();
  };
  /** 初始化资产数据 */
  const initAssetsData = async () => {
    const results = await Promise.allSettled([
      initCouponCount(),
      initWePointsCount(),
    ]);
    isReady.value = true;
    const hasFailResult = results.some(result => result.status === 'rejected');
    if (hasFailResult) {
      new CustomException(undefined, 'InitUserAssetsDataFail', '获取用户奖品数据失败');
    }
  };
  onMounted(() => {
    initAssetsData();
  });
  return {
    isReady,
    assetsCountData,
    /** 供外部（如首页领券成功后）主动刷新资产数量 */
    refresh: initAssetsData,
  };
}
